<template>
  <ModalDefault
    modal_id="integrationsModal"
    :size="
      ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
        channels.integration.name
      )
        ? 'modal-lg'
        : 'modal-lg'
    "
    header="y"
    :style_top_header="
      $mq === 'mobile' || $mq === 'tablet'
        ? 'position: fixed; top: 0; width: 100%; z-index: 999;'
        : ''
    "
    :style_footer="
      $mq === 'mobile' || $mq === 'tablet'
        ? 'position: fixed; bottom: 0; width: 100%; z-index: 999;'
        : ''
    "
    :style_body="
      $mq === 'mobile' || $mq === 'tablet'
        ? 'min-height: calc(100vh - 115px);'
        : ''
    "
    class_footer="border-0"
    :modal_header="
      ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
        channels.integration.name
      )
        ? ' WhatsApp Web' + ' QR (integração não oficial)'
        : channels.integration.name
    "
    
    class_body="p-0"
    footer="y"
  >
    <div slot="header">
      kkkkkkkkkk
    </div>
    <div slot="body">
      <!--Sub-Header-->
      <div v-if="false" class="card-header bg-white border-0">
        <div class="row">
          <div class="col-12 d-flex px-4">
            <div
              :class="view === 1 ? 'title-color font-weight-bold' : ''"
              @click.prevent="view = 1"
              class="pr-2 cursor_pointer"
            >
              <i class="bx bx-cog mr-2"></i>
              <small>{{ getTranslations("expression_62") }}</small>
            </div>
            <div
              :class="view === 2 ? 'title-color font-weight-bold' : ''"
              @click.prevent="view = 2"
              class="pl-4 cursor_pointer"
            >
              <i class="bx bx-info-circle mr-2"></i>
              <small>{{ getTranslations("expression_166") }}</small>
            </div>
          </div>
        </div>
      </div>
      <!--Body-->
      <div
        style=""
        class="card-body"
      >
        <div v-if="view === 1" class="px-2 pb-1">
          <div
            v-if="
              !['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
                channels.integration.name
              )
            "
            class="animated--fade-in row mt-1 pt-1 px-3"
            style="margin-bottom: -15px"
          >
            <div
              class="col-12 px-4 py-3 alert alert-info rounded-0 fade show"
              role="alert"
            >
              <span class="d-block pr-4">
                <i class="bx bx-info-circle mr-1"></i>
                {{ getTranslations("expression_767") }}
                <strong class="">
                  <a
                    v-if="['rdstation'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://crmsupport.rdstation.com.br/hc/pt-br/articles/360018468312-Gerar-e-visualizar-Token"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                  <a
                    v-if="['agendor'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://api.agendor.com.br/docs/"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                  <a
                    v-if="['hubspot'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://knowledge.hubspot.com/pt/conversations/how-do-i-add-personalization-tokens-to-a-template-or-snippet"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                  <a
                    v-if="['nectar'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://docs.nectarcrm.com.br/central-de-ajuda/introducao#open"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                  <a
                    v-if="['pipedrive'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://developers.pipedrive.com/docs/api/v1"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                  <a
                    v-if="['rbxsoft'].includes(channels.integration.name)"
                    style="font-family: 'Product Sans Bold'"
                    class="text-info"
                    href="https://wiki.rbxsoft.com/wiki/index.php/P%C3%A1gina_principal"
                    target="_blank"
                  >
                    {{ getTranslations("expression_768") }}
                  </a>
                </strong>
              </span>
            </div>
          </div>

          <div class="row pt-1 px-2">
            <div
              class="col-12"
              v-if="
                [
                  'rdstation',
                  'agendor',
                  'hubspot',
                  'nectar',
                  'pipedrive',
                  'bsms',
                  'whatsappbussinessapi',
                  'rbxsoft',
                ].includes(channels.integration.name)
              "
            >
              <label class="mb-0">Token </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.token"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['api4com'].includes(channels.integration.name)"
            >
              <label class="mb-0">Ramal </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.branch"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['rbxsoft'].includes(channels.integration.name)"
            >
              <label class="mb-0">URL Cliente </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.urlClient"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['rbxsoft'].includes(channels.integration.name)"
            >
              <label class="mb-0">URL Billet </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.urlBillet"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['wati'].includes(channels.integration.name)"
            >
              <label class="mb-0">ID </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.id"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['wati'].includes(channels.integration.name)"
            >
              <label class="mb-0">User </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.user"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['wati'].includes(channels.integration.name)"
            >
              <label class="mb-0">Password </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.password"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              class="col-12"
              v-if="['followize'].includes(channels.integration.name)"
            >
              <label class="mb-0">Client Key </label>
              <div class="input-group mb-4">
                <input
                  type="text"
                  v-model="channels.integration.data.clientKey"
                  class="input_forms form-control"
                />
              </div>
            </div>
            <div
              v-if="
                ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
                  channels.integration.name
                )
              "
              class="col-12"
              style="
                display: flex;
                justify-content: center;
                flex-direction: column;
              "
            >
              <div v-if="agreed">
                
                <p>Digitalize seu código QR</p>
                <p>Ao digitalizar este código QR, você aceita nossos <a href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_br" target="_blank">termos e condições</a> do Facebook (Meta).</p>
                <!--Feedback para ABRIR sessão / gerar QRCODE-->
                <!-- && baileys_integration.session_state !== 'open' && baileys_integration.session_state !== 'connecting'-->
                <div
                  v-if="
                    !baileys_integration.changing_session &&
                    baileys_integration.qrcode_url == null &&
                    baileys_integration.session_state === 'close'
                  "
                  class="d-flex flex-column"
                  style="justify-content: center; align-items: center"
                >
                  <lottie-player
                    src="https://lottie.host/a4d40203-15ef-4093-bcf0-e3f05991ac56/JJGJw7zR4E.json"
                    background="transparent"
                    speed="0.9"
                    style="width: 300px; height: 300px"
                    loop
                    autoplay
                  >
                  </lottie-player>
                  <span style="font-size: 1rem">{{
                    getTranslations("expression_207")
                  }}</span>
                </div>

                <!--QRCODE image-->
                <!--&& baileys_integration.session_state === 'connecting'-->
                <div
                  v-if="baileys_integration.qrcode_url != null"
                  style="display: flex; justify-content: center"
                >
                  <img
                    :src="baileys_integration.qrcode_url"
                    style="width: 350px; height: 350px"
                    class="v-responsive2"
                    alt=""
                  />
                  <p class="bx-5 by-5"></p>
                </div>

                <!--// connecting -> não leu ainda
              // open -> conectado
              // close -> desconectado-->

                <!--Feedback de sessão CONECTADA-->
                <div
                  v-else-if="
                    !baileys_integration.changing_session &&
                    baileys_integration.session_state === 'open'
                  "
                  class="d-flex flex-column"
                  style="justify-content: center; align-items: center"
                >
                  <lottie-player
                    src="https://lottie.host/051b4256-c21f-42ec-974b-d1716eff1a78/dvtjL4xpRJ.json"
                    background="transparent"
                    speed="1"
                    style="width: 300px; height: 300px"
                    loop
                    autoplay
                  >
                  </lottie-player>
                  <span class="mt-2" style="font-size: 25px">
                    {{ getTranslations("expression_1269") }}</span
                  >
                </div>

                <!--Feedback de sessão DESCONECTADA-->
                <div
                  v-else-if="
                    !baileys_integration.changing_session &&
                    baileys_integration.session_state === 'close'
                  "
                  class="d-flex flex-column"
                  style="justify-content: center; align-items: center"
                >
                  <span class="mt-2" style="font-size: 1rem">{{
                    getTranslations("expression_1276")
                  }}</span>
                </div>

                <!--Loader-->
                <div
                  v-else-if="
                    baileys_integration.changing_session ||
                    (baileys_integration.session_state !== 'open' &&
                      baileys_integration.session_state !== 'connecting')
                  "
                  class="d-flex"
                  style="justify-content: center"
                >
                  <div class="row animated--fade-in">
                    <div
                      class="col-12 d-flex"
                      style="
                        justify-content: center;
                        align-items: center;
                        min-height: 40vh;
                      "
                    >
                      <div class="row">
                        <div class="col-12 text-center">
                          <div
                            class="spinner-border text--primary"
                            style="width: 3.5rem; height: 3.5rem"
                            role="status"
                          ></div>
                        </div>
                        <div class="col-12 text-center cursor_default">
                          <small class="bx-flashing">
                            {{ getTranslations("expression_36") }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <v-row>
                  <v-col cols="3" class="text-center">
                    <svg width="114px" height="114px" viewBox="0 0 22 22" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" id="svg2" version="1.1" inkscape:version="0.92.1 r15371" sodipodi:docname="dark_warning.svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs id="defs4"> <linearGradient gradientUnits="userSpaceOnUse" y2="2" x2="16" y1="29.999973" x1="16" id="linearGradient4144" xlink:href="#linearGradient4155" inkscape:collect="always" gradientTransform="matrix(1.66667 0 0 -1.66667 -15.667 1064.696)"></linearGradient> <linearGradient inkscape:collect="always" id="linearGradient4155"> <stop style="stop-color:#fcd994;stop-opacity:1" offset="0" id="stop4157"></stop> <stop style="stop-color:#fff6e1;stop-opacity:1" offset="1" id="stop4159"></stop> </linearGradient> </defs> <sodipodi:namedview id="base" pagecolor="#ffffff" bordercolor="#666666" borderopacity="1.0" inkscape:pageopacity="0.0" inkscape:pageshadow="2" inkscape:zoom="22.4" inkscape:cx="-8.3436117" inkscape:cy="10.155389" inkscape:document-units="px" inkscape:current-layer="layer1" showgrid="true" inkscape:showpageshadow="false" borderlayer="true" inkscape:window-width="1884" inkscape:window-height="1051" inkscape:window-x="0" inkscape:window-y="0" inkscape:window-maximized="1" units="px"> <sodipodi:guide position="2,20.000017" orientation="18,0" id="guide4085" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="2,2.0000174" orientation="0,18" id="guide4087" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="20,2.0000174" orientation="-18,0" id="guide4089" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="20,20.000017" orientation="0,-18" id="guide4091" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="3,19.000017" orientation="16,0" id="guide4093" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="3,3.0000174" orientation="0,16" id="guide4095" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="19,3.0000174" orientation="-16,0" id="guide4097" inkscape:locked="false"></sodipodi:guide> <sodipodi:guide position="19,19.000017" orientation="0,-16" id="guide4099" inkscape:locked="false"></sodipodi:guide> <inkscape:grid type="xygrid" id="grid4101"></inkscape:grid> </sodipodi:namedview> <metadata id="metadata7"> <rdf:rdf> <cc:work> <dc:format>image/svg+xml</dc:format> <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type> <dc:title></dc:title> <dc:creator> <cc:agent> <dc:title>Timothée Giet</dc:title> </cc:agent> </dc:creator> <dc:date>2017</dc:date> <cc:license rdf:resource="http://creativecommons.org/licenses/by-sa/4.0/"></cc:license> </cc:work> <cc:license rdf:about="http://creativecommons.org/licenses/by-sa/4.0/"> <cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"></cc:permits> <cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"></cc:permits> <cc:requires rdf:resource="http://creativecommons.org/ns#Notice"></cc:requires> <cc:requires rdf:resource="http://creativecommons.org/ns#Attribution"></cc:requires> <cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"></cc:permits> <cc:requires rdf:resource="http://creativecommons.org/ns#ShareAlike"></cc:requires> </cc:license> </rdf:rdf> </metadata> <g inkscape:label="Capa 1" inkscape:groupmode="layer" id="layer1" transform="translate(0 -1030.362)"> <path style="fill:#ff5c5c;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="m11 1032.362-10 18h20zm0 2 8 15H3z" id="path839" inkscape:connector-curvature="0" sodipodi:nodetypes="cccccccc"></path> <path style="fill:#373737;fill-opacity:.94117647;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M10 1046.362h2v2h-2z" id="path844" inkscape:connector-curvature="0"></path> <path style="fill:#373737;fill-opacity:.94117647;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="M10 1045.362h2v-6h-2z" id="path846" inkscape:connector-curvature="0" sodipodi:nodetypes="ccccc"></path> </g> </g></svg>
                  </v-col>
                  <v-col cols="9">
                    <p>
                      <strong>Nota:</strong> A integração com o QR do WhatsApp Web não é uma integração definitiva e depende da conexão do seu telefone.
                    </p>
                    <span>
                      Essa integração pode ser útil para testar as funções da plataforma para integrar o WhatsApp através da API do WhatsApp (integração oficial), <a target="_blank" href="https://docs.beecrm.io/configuracao-do-canal/canais/whatsapp-web-qr">visite nossa base de conhecimento</a> e entre em contato com nossa equipe para que possamos ajudá-lo no processo.
                    </span>
                    <span class="d-block mt-3 mb-3 text-center">
                      <input
                        class="cursor_pointer"
                        type="checkbox"
                        v-model="agreed"
                      />
                      Confirmo que li o guia
                    </span>
                  </v-col>
                </v-row>
                
                
              </div>
            </div>
          </div>
        </div>

        <div v-if="false && view === 2" class="animated--grow-in px-2 pb-1">
          <!--Release-->
          <div class="row pt-1 px-2">
            <!--RD STATION-->
            <div
              class="col-12"
              v-if="['rdstation'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_769") }}
              </h5>
              <span>
                {{ getTranslations("expression_770") }}
              </span>
            </div>
            <!--AGENDOR-->
            <div
              class="col-12"
              v-if="['agendor'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_771") }}
              </h5>
              <span>
                {{ getTranslations("expression_772") }}
              </span>
            </div>
            <!--HUBSPOT-->
            <div
              class="col-12"
              v-if="['hubspot'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_773") }}
              </h5>
              <span>
                {{ getTranslations("expression_774") }}
              </span>
            </div>
            <!--NECTAR CRM-->
            <div
              class="col-12"
              v-if="['nectar'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_775") }}
              </h5>
              <span>
                {{ getTranslations("expression_776") }}
              </span>
            </div>
            <!--PIPEDRIVE-->
            <div
              class="col-12"
              v-if="['pipedrive'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_777") }}
              </h5>
              <span>
                {{ getTranslations("expression_778") }}
              </span>
            </div>
            <!--RBX SOFT-->
            <div
              class="col-12"
              v-if="['rbxsoft'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_779") }}
              </h5>
              <span>
                {{ getTranslations("expression_780") }}
              </span>
            </div>
            <!--FOLLOWIZE-->
            <div
              class="col-12"
              v-if="['followize'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_781") }}
              </h5>
              <span>
                {{ getTranslations("expression_782") }}
              </span>
            </div>
            <!--BSMS-->
            <div
              class="col-12"
              v-if="['bsms'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_783") }}
              </h5>
              <span>
                {{ getTranslations("expression_784") }}
              </span>
            </div>
            <!--360 DIALOG-->
            <div
              class="col-12"
              v-if="
                ['whatsappbussinessapi'].includes(channels.integration.name)
              "
            >
              <h5 class="title-color">
                {{ getTranslations("expression_785") }}
              </h5>
              <span>
                {{ getTranslations("expression_786") }}
              </span>
            </div>
            <!--API4COM-->
            <div
              class="col-12"
              v-if="['api4com'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_787") }}
              </h5>
              <span>
                {{ getTranslations("expression_788") }}
              </span>
            </div>
            <!--WATI-->
            <div
              class="col-12"
              v-if="['wati'].includes(channels.integration.name)"
            >
              <h5 class="title-color">
                {{ getTranslations("expression_789") }}
              </h5>
              <span>
                {{ getTranslations("expression_786") }}
              </span>
            </div>
            <!--Wpp Web QR Code -->
            <div
              v-if="
                ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
                  channels.integration.name
                )
              "
              class="col-12"
            >
              <h5 class="title-color">
                <!--{{ getTranslations('expression_1265') }}-->
                Sobre WhatsApp QR Code
              </h5>
              <span>
                <!--{{ getTranslations('expression_786') }}-->
                Integração com WhatsApp Web
              </span>
            </div>
          </div>

          <!--Know-how-->

          <!--RD STATION-->
          <div
            class="row pt-1 px-2"
            v-if="['rdstation'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_791") }}
              </p>
              <p>
                {{ getTranslations("expression_1134") }}
                {{ configs.data.partner.name }}".
              </p>
            </div>
          </div>
          <!--AGENDOR-->
          <div
            class="row pt-1 px-2"
            v-if="['agendor'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_792") }}
              </p>
            </div>
          </div>
          <!--HUBSPOT-->
          <div
            class="row pt-1 px-2"
            v-if="['hubspot'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_793") }}
              </p>
            </div>
          </div>
          <!--NECTAR CRM-->
          <div
            class="row pt-1 px-2"
            v-if="['nectar'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_794") }}
              </p>
            </div>
          </div>
          <!--PIPEDRIVE-->
          <div
            class="row pt-1 px-2"
            v-if="['pipedrive'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_795") }}
              </p>
            </div>
          </div>
          <!--RBX SOFT-->
          <div
            class="row pt-1 px-2"
            v-if="['rbxsoft'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_796") }}
              </p>
            </div>
          </div>
          <!--FOLLOWIZE-->
          <div
            class="row pt-1 px-2"
            v-if="['followize'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                {{ getTranslations("expression_797") }}
              </p>
            </div>
          </div>
          <!--BSMS-->
          <div
            class="row pt-1 px-2"
            v-if="['bsms'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <p>
                Ao integrar o seu CRM com o BSMS você compartilhará
                automaticamentente as informações dos seus leads com esse
                fornecedor. As informações que podem ser enviadas são as
                seguintes: Nome, E-mail e Telefone.
              </p>
            </div>
          </div>

          <!--360 DIALOG-->
          <!--<div class="row pt-1 px-2" v-if="['whatsappbussinessapi'].includes(channels.integration.name)">
            <div class="col-12 ">
              <h5 class="title-color">
                {{ getTranslations('expression_790') }}
              </h5>
              <p>
                Ao integrar o seu CRM com o Followize você compartilhará automaticamentente as informações dos seus leads com esse fornecedor.
                As informações que podem ser enviadas são as seguintes: Nome, E-mail e Telefone.
              </p>
            </div>
          </div>-->

          <!--API4COM-->
          <div
            class="row pt-1 px-2"
            v-if="['api4com'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>

              <!--<p>
                Mussum Ipsum, cacilds vidis litro abertis. Nullam volutpat risus nec leo commodo, ut interdum diam laoreet. Sed non consequat odio. Todo mundo vê os porris que eu tomo, mas ninguém vê os tombis que eu levo! Casamentiss faiz malandris se pirulitá. Posuere libero varius. Nullam a nisl ut ante blandit hendrerit. Aenean sit amet nisi.
              </p>-->
            </div>
          </div>

          <!--WATI-->
          <div
            class="row pt-1 px-2"
            v-if="['wati'].includes(channels.integration.name)"
          >
            <div class="col-12">
              <h5 class="title-color">
                {{ getTranslations("expression_790") }}
              </h5>
              <!--<p>
                Mussum Ipsum, cacilds vidis litro abertis. Nullam volutpat risus nec leo commodo, ut interdum diam laoreet. Sed non consequat odio. Todo mundo vê os porris que eu tomo, mas ninguém vê os tombis que eu levo! Casamentiss faiz malandris se pirulitá. Posuere libero varius. Nullam a nisl ut ante blandit hendrerit. Aenean sit amet nisi.
              </p>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Footer-->
    <div
      slot="footer"
      class="col-12 d-flex cursor_default text-left py-2 ellipsis pl-4 pr-3"
      :class="
        ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
          channels.integration.name
        )
          ? 'justify-content-end'
          : 'justify-content-between'
      "
    >
      <div
        v-show="
          !['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
            channels.integration.name
          )
        "
      >
        <span
          v-b-tooltip.top
          :title="
            channels.integration ? channels.integration.status_key : '---'
          "
          :class="
            channels.integration.status_key ? `bg-success` : 'bg-secondary'
          "
          class="text-white py-2 px-3"
        >
          <span class="">{{
            channels.integration.status_key
              ? getTranslations("expression_425")
              : getTranslations("expression_426")
          }}</span>
        </span>
      </div>
      <div class="d-flex">
        <div
          v-if="
            !['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
              channels.integration.name
            )
          "
        >
          <!--v-if="channels.integration.data.token ||
          (channels.integration.data.teamKey && channels.integration.data.clientKey && channels.integration.data.sendFirstMessage) ||
          channels.integration.data.branch"-->
          <span
            @click.prevent="saveChannel"
            data-dismiss="modal"
            class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3"
          >
            <i class="bx bxs-save"></i>
            <span class="ml-2">{{ getTranslations("expression_120") }}</span>
          </span>
        </div>

        <div
          v-else-if="
            ['whatsappwebqrcode', 'whatsappwebqrcode_2.0'].includes(
              channels.integration.name
            ) && !baileys_integration.changing_session
          "
        >
          <div v-if="agreed">
            <span
              v-if="
                !baileys_integration.qrcode_url &&
                baileys_integration.session_state === 'close'
              "
              @click.prevent="connectSession"
              class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <i class="bx bx-log-in"></i>
              <span class="ml-2">{{ getTranslations("expression_957") }}</span>
            </span>

            <span
              v-if="
                baileys_integration.session_state === 'open' &&
                baileys_integration.session_state !== 'connecting'
              "
              @click.prevent="disconnectSession"
              class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <i class="bx bx-log-out"></i>
              <span class="ml-2">{{ getTranslations("expression_1267") }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import Loader from "../general/Loader.vue";
import Swal from "sweetalert2";
import Pusher from "pusher-js";
import io from "socket.io-client";
import { api } from "../../services";
import baileys_integration from "../../store/modules/baileys_integration";
import * as moment from "moment/moment";

export default {
  name: "ModalIntegrations",
  components: {
    Loader,
    ModalDefault,
  },
  data() {
    return {
      view: 1,
      connected: false,
      changing_session: true,
      agreed: false,
      // socket_baileys: null
    };
  },
  mounted() {
    $('#integrationsModal').on('show.bs.modal', () => {
      let channel_id = this.channels.channel.id;
      let current_url = this.configs.current_url;
      let current_session = `${channel_id}-${current_url}`;

      // path: `/${channel_id}-${current_url}`
      this.baileys_integration.socket_baileys = io(`https://spinoza.beecrm.io`, { transports: ['websocket'] });

      this.baileys_integration.socket_baileys.on('connect', () => {
        console.log('Conectado ao WebSocket da Evolution API');
      });

      this.baileys_integration.socket_baileys.on('qrcode.updated', (data) => {
        if(data.instance === current_session) {
          // let timestamp = 
          this.baileys_integration.qrcode_url = `${data.data.qrcode.base64}`;
          this.baileys_integration.changing_session = false;
        }
      });

      this.baileys_integration.socket_baileys.on('connection.update', (data) => {
        if(data.instance === current_session) {
          if(data.data.state === 'open') {
            this.baileys_integration.changing_session = false;
            this.baileys_integration.session_state = 'open';
            this.baileys_integration.qrcode_url = null;
          }
        }
      });

      setTimeout(() => {
        this.baileys_integration.changing_session = false
      }, 3000)
    });
    $("#integrationsModal").on("hidden.bs.modal", () => {
      this.view = 1;
      this.baileys_integration.qrcode_url = null;
      this.baileys_integration.changing_session = true;
      this.baileys_integration.id_integration = null;
      if (this.baileys_integration.socket_baileys) {
        this.baileys_integration.socket_baileys.disconnect();
      }
    });
  },
  watch: {
    /*Observa o qrcode_url*/
    "baileys_integration.qrcode_url": function (val) {
      if (baileys_integration.qrcode_url === null) {
        this.$store.dispatch("verifyIfSessionExists", this.channels.channel);
      }
    },
  },
  computed: {
    ...mapState(["channels", "configs"]),
    ...mapGetters(["getDepartmentObject", "getDepartmentsArray"]),
  },
  methods: {
    saveChannel() {
      if (
        [
          "rdstation",
          "agendor",
          "hubspot",
          "nectar",
          "pipedrive",
          "rbxsoft",
        ].includes(this.channels.integration.name) &&
        !this.channels.integration.data.token
      ) {
        // alert(this.getTranslations('expression_798'))
        this.channels.integration.status_key = false;
        this.$store.dispatch("updateChannel", this.channels.channel);
      } else {
        this.$store.dispatch("updateChannel", this.channels.channel);
        $("#integrationsModal").modal("hide");
      }
      if (
        this.channels.channel.integrations[9].status_key &&
        this.channels.channel.integrations[9].data.token &&
        this.channels.channel.integrations[9].data.token !== ""
      ) {
        setTimeout(() => {
          this.$store.dispatch("syncWebhookChannel");
        }, 2000);
      }
    },
    connectSession() {
      this.$store.dispatch("connectSession", this.channels.channel);
    },
    agreedWithNotice(){
      setTimeout(() => { 
        //this.$store.dispatch("connectSession", this.channels.channel);
      }, 500);
    },
    disconnectSession() {
      this.$store.dispatch("disconnectSession", this.channels.channel);
      // this.changing_session = true
      // if (this.channels.socket_baileys) {
      //   this.channels.socket_baileys.disconnect();
      // }
      //
      // const isProduction = document.URL.split('/')[0] == 'https:';
      // const channel_id = this.channels.channel.id
      // const url_deploy = isProduction
      //   ? document.URL.split('/')[2]
      //   : 'dev.localhost.io'
      //
      // api.delete(`https://lemmonbaileys.beecrm.io/api/whatsapp/channel/${channel_id}-${url_deploy}/delete`, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Accept': 'application/json'
      //   }
      // }).then(() => {
      //   Swal.fire({
      //     position: 'center',
      //     icon: 'success',
      //     title: 'Sessão desconectada',
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // })
      //
      // // Salva as informações da integração do baileys no back-end do beecrm
      // api.post(`/channels/set-session-baileys/${channel_id}`, { session: false })
      //   .then((response) => {
      //     this.channels.channel = response.data
      //     this.channels.integration = response.data.integrations[11]
      //     this.channels.qrcode_url = null
      //     this.changing_session = false
      //   });
    },
  },
};
</script>

<style scoped>
.v-responsive2 {
  max-width: 100%;
    overflow: hidden;
    position: relative;
}
</style>
